import { QUERY_PARAMS } from 'routes/consts';

export const STEP_IDS = {
  CONFIGURE_APP: 'configure-app',
  CONFIGURE_TOKEN: 'configure-token',
  INSTALL_APP: 'install-app',
  CREATE_APP_GUIDE: 'create-app-guide',
  CREATE_SERVICE_ACCOUNT_GUIDE: 'create-service-account-guide',
  CONNECT_REPOSITORIES: 'connect-repositories',
  CHECK_CONNECTION: 'check-connection',
  ENABLE_QODO: 'enable-qodo',
  BEFORE_YOU_BEGIN: 'before-you-begin',
};

export const FORM_IDS = {
  CONFIGURE_APP: 'configure-app-form',
  CONFIGURE_TOKEN: 'configure-token-form',
  CONFIGURE_MT_APP: 'configure-mt-app-form',
  CREATE_SERVICE_ACCOUNT: 'create-service-account-form',
  CONNECT_REPOSITORIES: 'connect-repos-form',
};

export const CONFIGURE_APP_FIELDS = {
  CLIENT_ID: 'clientId',
  CLIENT_SECRET: 'clientSecret',
  GITLAB_URL: 'gitlabUrl',
} as const;

export const CONFIGURE_MT_APP_FIELDS = {
  GITLAB_URL: 'gitlabUrl',
} as const;

export const CONFIGURE_TOKEN_FIELDS = {
  ACCESS_TOKEN: 'accessToken',
  GITLAB_URL: 'gitlabUrl',
  GITLAB_URLS: 'gitlabUrls',
} as const;

export const GITLAB_ERROR_CODES = {
  AUTHORIZATION_FAILED: 'AUTHORIZATION_FAILED',
  MISSING_CODE: 'MISSING_CODE',
  INVALID_STATE: 'INVALID_STATE',
  CONFIG_NOT_FOUND: 'CONFIG_NOT_FOUND',
  GITLAB_API_ERROR: 'GITLAB_API_ERROR',
  UNEXPECTED_ERROR: 'UNEXPECTED_ERROR',
  INVALID_SERVICE_ACCOUNT: 'INVALID_SERVICE_ACCOUNT',
  INSUFFICIENT_ACCESS_LEVEL: 'INSUFFICIENT_ACCESS_LEVEL',
  GITLAB_ID_ALREADY_CLAIMED: 'GITLAB_ID_ALREADY_CLAIMED',
  AUTH_TYPE_MISMATCH: 'AUTH_TYPE_MISMATCH',
  // Specific causes split out of the generic GITLAB_API_ERROR by the backend so
  // the wizard can tell the user what to fix (matches GitLabCallbackErrorCode).
  INVALID_URL: 'INVALID_URL',
  GROUP_NOT_FOUND: 'GROUP_NOT_FOUND',
  INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
} as const;

export const SELECTION_ACTIONS = {
  TOGGLE_PROJECT: 'TOGGLE_PROJECT',
  TOGGLE_WHOLE_GROUP: 'TOGGLE_WHOLE_GROUP',
  SELECT_ALL_GROUPS: 'SELECT_ALL_GROUPS',
  SET_SELECTED_PROJECTS: 'SET_SELECTED_PROJECTS',
  SET_EXPANDED_GROUPS: 'SET_EXPANDED_GROUPS',
  REGISTER_GROUP_PROJECTS: 'REGISTER_GROUP_PROJECTS',
  CLEAR_GROUP_PROJECTS: 'CLEAR_GROUP_PROJECTS',
  DESELECT_GROUP_AND_EXCLUDE_PROJECT: 'DESELECT_GROUP_AND_EXCLUDE_PROJECT',
  RESET_SELECTION: 'RESET_SELECTION',
} as const;

export const GITLAB_CALLBACK_PATH = '/callback';

// Multi-group (B-v1a): the OAuth callback redirects with this status instead of
// `success` — the wizard then calls provision-groups to finish.
export const GITLAB_CALLBACK_STATUS = {
  AWAITING_PROVISION: 'awaiting_provision',
} as const;

export const OAUTH_CALLBACK_PARAMS = [
  QUERY_PARAMS.STATUS,
  QUERY_PARAMS.ERROR_CODE,
  QUERY_PARAMS.APP_CONFIG_ID,
  QUERY_PARAMS.INSTALLATION_ID,
] as const;

export const QODO_LOGO_URL = '/images/github-installation/qodo-logo.png';
export const QODO_LOGO_FILENAME = 'qodo-logo.png';

export const ENABLE_QODO_TRANSLATION_KEY =
  'dialogs.gitlab-installation.enable-qodo';
